import React, { useState } from 'react'
import { useDeviceStage } from '../../../../CustomHooks/useDeviceStage'
import { updateBulkDeviceDetails } from '../../../../services/configurationServices'
import { SuccessToast } from '../../../../CustomHooks/SuccessToast'
import { ErrorToast } from '../../../../CustomHooks/ErrorToast'

const CCTVEditForm = ({ zoneOptions, setShowBulkEditModal, selectedDeviceIds, handleApplyFilters, setBulkEditLoading }) => {

    const [selectedZone, setSelectedZone] = useState('')
    const [errors, setErrors] = useState({
        zoneName: '',
        deviceStage: ''
    })
    const [isPTZ, setIsPTZ] = useState(false)
    const [parentIsEncoding, setParentIsEncoding] = useState(false)
    const [parentIsPlaybackEncoding, setParentIsPlaybackEncoding] = useState(false)
    const [parentIsEnablingUTCPlayback, setParentIsEnablingUTCPlayback] = useState(false)
    const [deviceStageId, setDeviceStageId] = useState('')

    const { deviceStage } = useDeviceStage();

    const onBulkEditSubmit = async (e) => {
        e.preventDefault();
        let tempErrors = {
            zoneName: '',
            deviceStage: ''   
        }
        let isValid = true
        if(selectedZone === '' || selectedZone === null || selectedZone === undefined){
            tempErrors.zoneName = 'Please select zone'
            isValid = false
        }
        if(deviceStageId === '' || deviceStageId === null || deviceStageId === undefined){
            tempErrors.deviceStage = 'Please select device stage'
            isValid = false
        }
        if(!isValid){
            setErrors(tempErrors)
            return;
        }
        try {
        setBulkEditLoading(true)
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const userID = user.Id || '';
        const payload = {
            UserID: userID,
            DeviceID: selectedDeviceIds.map(id => parseInt(id)),// Convert to numbers
            SiteID: parseInt(selectedZone),
            DeviceStageId: parseInt(deviceStageId), 
            IsPtz: Number(isPTZ),
            ISPlaybackUTC: parentIsEnablingUTCPlayback,
            IsTranscodingEnabled: parentIsEncoding,
            IsPlayBackTranscodingEnabled: parentIsPlaybackEncoding
        };
        const response = await updateBulkDeviceDetails(payload);
              if (response && response.Status === 'success') {
                SuccessToast(response.Message || 'Devices updated successfully');
                setShowBulkEditModal(false);
                handleApplyFilters(); // Refresh the data
              } else {
                ErrorToast(response?.Message || 'Failed to update devices. Please try again.');
              }
        } catch (error) {
            console.error('Error updating devices:', error);
            ErrorToast('An error occurred while updating devices. Please try again.');
        }finally{
            setBulkEditLoading(false)
        }
    }

    const clearError = (field) => {
        setErrors(prevErrors => ({
            ...prevErrors,
            [field]: ''
        }));
    };

    return (
        <div className='border-top-0' style={{ display: 'flex', flexDirection: 'column' }}>

            <div>

                <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Zone*</label>
                        <select
                            className="inputType ArrowSelectClass"
                            value={selectedZone}
                            onChange={(e) => {
                                setSelectedZone(e.target.value)
                                clearError('zoneName')
                            }}
                        >
                            <option value="">Select Zone*</option>
                            {zoneOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        {(errors.zoneName) && (
                            <p className="Error_P" style={{ float: "left" }}><span> {errors.zoneName} </span></p>
                        )}
                    </div>
                </div>

                <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Enable Transcoding</label>
                        <div className='mt-1 signTypeCheckboxLabels'>
                            <div className="SiteTextBox SiteNameText mt-0">
                                <div className="onlyforEnableCheckbox ml-0">
                                    <input
                                        className="checkbox_custom"
                                        type="checkbox"
                                        id="EnableTranscoding"
                                        onChange={(e) => {
                                            setParentIsEncoding(e.target.checked);
                                        }}
                                    />
                                    <label className="mb-0"
                                        htmlFor='EnableTranscoding'
                                        onClick={() => {
                                            if (parentIsEncoding) {
                                                setParentIsEncoding(false);
                                            } else {
                                                setParentIsEncoding(true);
                                            }
                                        }}
                                    >
                                        Live Enable Transcoding to H.264 <sup>(Optional)</sup>
                                    </label>
                                </div>
                            </div>

                            <div className="SiteTextBox SiteNameText mt-0">
                                <div className="onlyforEnableCheckbox">
                                    <input
                                        className="checkbox_custom"
                                        type="checkbox"
                                        id="PlaybackEnableTranscoding"
                                        onChange={(e) => {
                                            setParentIsPlaybackEncoding(e.target.checked);
                                        }}
                                    />
                                    <label className="mb-0"
                                        htmlFor='PlaybackEnableTranscoding'
                                        onClick={() => {
                                            if (parentIsPlaybackEncoding) {
                                                setParentIsPlaybackEncoding(false);
                                            } else {
                                                setParentIsPlaybackEncoding(true);
                                            }
                                        }}
                                    >
                                        Playback Enable Transcoding to H.264 <sup>(Optional)</sup>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Enable PTZ</label>
                        <div className="onlyforEnableCheckbox">
                            
                            <input
                                className="checkbox_custom"
                                type="checkbox"
                                id="EnablePTZ"
                                value={isPTZ}
                                onChange={(e) => {
                                    setIsPTZ(e.target.checked);
                                }}
                            />
                            <label className="mb-0" 
                                htmlFor='EnablePTZ'
                            >
                                {/* onClick={() => {
                                    if (isPTZ) {
                                        setIsPTZ(false);
                                    } else {
                                        setIsPTZ(true);
                                    }
                                }} */}
                            
                                Enable PTZ
                            </label>
                        </div>
                    </div>
                </div>

                <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Enable Playback in UTC</label>
                        <div className="onlyforEnableCheckbox">
                            <input
                                className="checkbox_custom"
                                type="checkbox"
                                id="EnablePlaybackInUTC"
                                value={parentIsEnablingUTCPlayback}
                                onChange={(e) => {
                                    setParentIsEnablingUTCPlayback(e.target.checked);
                                }}
                            />
                            <label className="mb-0"
                                htmlFor='EnablePlaybackInUTC'
                                onClick={() => {
                                    if (parentIsEnablingUTCPlayback) {
                                        setParentIsEnablingUTCPlayback(false);
                                    } else {
                                        setParentIsEnablingUTCPlayback(true);
                                    }
                                }}
                            >
                                Enable Playback in UTC
                            </label>
                        </div>
                    </div>
                </div>

                <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Device Stage*</label>
                        <select
                            className="inputType ArrowSelectClass"
                            placeholder="Device stage"
                            value={deviceStageId}
                            onChange={(e) => {
                                setDeviceStageId(e.target.value)
                                clearError('deviceStage')
                            }}

                        >
                            <option key="0" value="0" id="0">Select Device stage*</option>
                            {deviceStage &&
                                deviceStage.map((val) => (
                                    <option
                                        value={val.StageID} key={val.StageID}
                                        id={val.StageID}>
                                        {val.StageName}
                                    </option>
                                ))}
                        </select>
                        {errors.deviceStage && <p className="Error_P" style={{ float: "left" }}><span>{errors.deviceStage}</span></p>}
                    </div>
                </div>

            </div>

            <div style={{ textAlign: "center" }}>
                <button
                    className="DataAccessEdit mt-3"
                    style={{ width: "100px" }}
                    // disabled={bulkEditLoading}
                    onClick={onBulkEditSubmit}
                >
                    <span className="ViewUpdate">Submit</span>
                </button>
                <button
                    onClick={() => setShowBulkEditModal(false)}
                    className="DataAccessEdit mt-3"
                    style={{ width: "100px" }}
                // disabled={bulkEditLoading}
                >
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>

        </div>
    )
}

export default CCTVEditForm